module.exports = __webpack_public_path__ + "static/octopus-068cf077519c5a2387b0cf05ff5d6749.svg";